import { useChatStore } from '@/store';
import { findChatById } from '@/lib/chatIndex';
import { findMessageById } from '@/lib/messageIndex';
import { isAwaitingRequestedMedia } from '@/constants/utils/message';

// Require a loaded Chat conversation; Work history uses the same message UI.
export default function useChatWaitingGame(conversationId, messageId, requireMedia = false) {
  return useChatStore(state => {
    const chat = findChatById(state.chats, conversationId);
    const message = findMessageById(chat?.messages, messageId);
    return !!chat && !chat.coworkerSession && !chat.flags?.isCoworkerSession
      && !chat.workSync?.taskId && !chat.taskId
      && (!requireMedia || (message?.role !== 'user' && !message?.flags?.isDeleted && isAwaitingRequestedMedia(message)))
      && (!message?.isRequestingMedia || isAwaitingRequestedMedia(message));
  });
}
